import type { CSSObjectWithLabel, GroupBase, StylesConfig } from "react-select";

export const REACT_SELECT_PORTAL_PROPS = {
  menuShouldScrollIntoView: false,
  menuPortalTarget: document.body,
  menuPosition: "fixed" as const,
};

const DEFAULT_OBSTACLES = [".app-header", ".contact-edit-actions", ".app-footer"];

export const getReactSelectMenuPlacement = (
  controlRect: DOMRect,
  {
    preferredMenuHeight = 220,
    obstacleSelectors = DEFAULT_OBSTACLES,
  }: {
    preferredMenuHeight?: number;
    obstacleSelectors?: string[];
  } = {}
): { placement: "top" | "bottom"; maxMenuHeight: number } => {
  const padding = 8;
  let bottomLimit = window.innerHeight - padding;
  let topLimit = padding;

  obstacleSelectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.height <= 0) return;

      if (rect.top > controlRect.top && rect.top < bottomLimit) {
        bottomLimit = rect.top - padding;
      }

      if (rect.bottom <= controlRect.top && rect.bottom > topLimit) {
        topLimit = rect.bottom + padding;
      }
    });
  });

  const spaceBelow = bottomLimit - controlRect.bottom - padding;
  const spaceAbove = controlRect.top - topLimit;
  const openUp = spaceBelow < preferredMenuHeight && spaceAbove > spaceBelow;
  const placement = openUp ? "top" : "bottom";
  const available = openUp ? spaceAbove : spaceBelow;

  return {
    placement,
    maxMenuHeight: Math.max(100, Math.min(preferredMenuHeight, available - padding)),
  };
};

export const reactSelectPortalStyles: StylesConfig<unknown, boolean, GroupBase<unknown>> = {
  menuPortal: (base) =>
    ({
      ...base,
      zIndex: 100000,
      pointerEvents: "auto",
    }) as CSSObjectWithLabel,
  menu: (base) =>
    ({
      ...base,
      zIndex: 100000,
      backgroundColor: "#fff",
    }) as CSSObjectWithLabel,
};
